import { Selection } from 'prosemirror-state'
import { ResolvedPos } from 'prosemirror-model'

export const getNextTextPosition = ($pos: ResolvedPos): ResolvedPos =>
  $pos.doc.resolve(
    Selection.near($pos.doc.resolve($pos.pos < $pos.doc.nodeSize - 2 ? $pos.pos + 1 : $pos.doc.nodeSize - 2)).from,
  )
